import { GramStoriesPostProps } from "../../../Components/TheGramStoriesApp/TheGramStoriesAppInterfaces";

// Note: The NEW images need to be added to the directory
// For now, using the existing images until NEW versions are available
import pic1 from "./DublinTheGramAssets/TheGram-Pic-01.webp";
import pic2 from "./DublinTheGramAssets/TheGram-Pic-02.webp";
import pic3 from "./DublinTheGramAssets/TheGram-Pic-03.webp";
import pic4 from "./DublinTheGramAssets/TheGram-Pic-04.webp";
import pic5 from "./DublinTheGramAssets/TheGram-Pic-05.webp";

import dp1 from "./DublinTheGramAssets/TheGram-ProfilePic.webp";

// Dummy comment data

export const DublinTheGramStoriesContent: GramStoriesPostProps[] = [
  {
    Profile: { name: "@EasterRisingS2", image: dp1 },
    Date: "24 April 2025, 8:14 AM",
    Image: pic1,
    Likes: "342",
    Caption: "A day in the life of... a D.O.P!",
    Location: "Dublin, Ireland",
  },
  {
    Profile: { name: "@EasterRisingS2", image: dp1 },
    Date: "24 April 2025, 10:36 AM",
    Image: pic2,
    Likes: "456",
    Caption: "Taking a break with the crew ✌️",
    Location: "Dublin, Ireland",
  },
  {
    Profile: { name: "@EasterRisingS2", image: dp1 },
    Date: "24 April 2025, 11:47 AM",
    Image: pic3,
    Likes: "523",
    Caption: "Getting the lighting just right!",
    Location: "Dublin Castle, Ireland",
  },
  {
    Profile: { name: "@EasterRisingS2", image: dp1 },
    Date: "24 April 2025, 1:06 PM",
    Image: pic4,
    Likes: "389",
    Caption: "Mmm, time for a group lunch!",
    Location: "Dublin, Ireland",
  },
  {
    Profile: { name: "@EasterRisingS2", image: dp1 },
    Date: "24 April 2025, 1:33 PM",
    Image: pic5,
    Likes: "612",
    Caption: "Now I have 4 hours of back-to-back shooting, wish me luck!",
    Location: "Dublin, Ireland",
  },
];
